import { render, staticRenderFns } from "./minyi.vue?vue&type=template&id=40aa06e6&scoped=true&"
import script from "./minyi.vue?vue&type=script&lang=js&"
export * from "./minyi.vue?vue&type=script&lang=js&"
import style0 from "./minyi.vue?vue&type=style&index=0&id=40aa06e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa06e6",
  null
  
)

export default component.exports